module.exports = __webpack_public_path__ + "img/1.e2b37987.jpg";